import request from '../request'
//抽奖记录
export const CdKeyIndexRequest = p => {
    return request({
        method:'GET',
        url:'CdKey/Index',
        params: p
    })
}